<template>
  <div>
    <div class="p-head">
      <span class="btn q" @click="showInterst = false">取消</span>
      <span class="title">{{ title }}</span>
      <span class="btn w" @click="handleConfirm"
        >完成({{ selectedInterst.length }})</span
      >
    </div>

    <van-tree-select
      height="80vw"
      :items="items"
      :main-active-index.sync="active"
    >
      <template #content>
        <div>
          <van-checkbox
            v-model="items[active].allChecked"
            checked-color="#ee0a24"
            icon-size="16px"
            style="margin: 10px 0 5px 10px"
            @click="handleChange"
            >全选</van-checkbox
          >
          <span
            class="section-item"
            :class="{
              active: isInArray(items[active].selectedArr, item),
            }"
            v-for="item in currentInsterstArr"
            :key="item"
            @click="onChoose(item)"
            >{{ item }}</span
          >
        </div>
      </template>
    </van-tree-select>
  </div>
</template>

<script>
import "vant/lib/index.css";
import { TreeSelect, Checkbox } from "vant";

export default {
  components: {
    [TreeSelect.name]: TreeSelect,
    [Checkbox.name]: Checkbox,
  },
  props: {
    title: String,
    items: Array,
  },
  data() {
    return {
      active: 0,
    };
  },
  computed: {
    // 当前二级类目项目
    currentInsterstArr() {
      let t = this.items.find((item) => {
        return item.id == this.active;
      });
      return t.children;
    },
    // 所有选中的二级类目
    selectedInterst() {
      let arr = [];
      this.items.forEach((item) => {
        arr = arr.concat(item.selectedArr);
      });
      return arr;
    },
  },
  methods: {
    // 判断是否已存在在数组中
    isInArray(arr, item) {
      return arr.some((e) => e === item);
    },
    // 二级类目选中
    onChoose(item) {
      if (this.isInArray(this.items[this.active].selectedArr, item)) {
        let index = this.items[this.active].selectedArr.indexOf(item);
        this.items[this.active].selectedArr.splice(index, 1);
      } else {
        this.items[this.active].selectedArr.push(item);
      }
      // 二级类目选中的个数
      this.items[this.active].badge =
        this.items[this.active].selectedArr.length;
      if (this.items[this.active].selectedArr.length == 0)
        delete this.items[this.active].badge;
      else if (
        this.items[this.active].selectedArr.length ==
        this.items[this.active].children.length
      )
        this.items[this.active].allChecked = true;
      else this.items[this.active].allChecked = false;
    },
    // 点击全选
    handleChange() {
      let isCheck = this.items[this.active].allChecked;
      this.items[this.active].selectedArr = isCheck
        ? [...this.items[this.active].children]
        : [];
      if (isCheck)
        this.items[this.active].badge = this.items[this.active].children.length;
      else delete this.items[this.active].badge;
    },
    handleConfirm() {
      this.$emit("confirm", this.selectedInterst);
    },
  },
};
</script>

<style lang="less" scoped>
.p-head {
  padding: 16px;
  text-align: center;
  border-bottom: solid 1px #ebeef5;
  overflow: hidden;
  .title {
    font-weight: bold;
    font-size: 16px;
  }
  .btn {
    cursor: pointer;
    &.q {
      float: left;
      visibility: hidden;
    }
    &.w {
      float: right;
      color: #ec345c;
    }
  }
}

::v-deep  .van-tree-select {
  .van-sidebar {
    &::-webkit-scrollbar {
      width: 3px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-track {
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      border-radius: 10px;
      background-color: #f5f5f5;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 10px;
      box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.1);
      background-color: #c8c8c8;
    }
  }
  .van-tree-select__content {
    flex: 3;
  }
}
.section-item {
  display: inline-block;
  padding: 3px 0;
  margin: 5px;
  width: 29%;
  text-align: center;
  color: #303133;
  border: solid 1px #ebeef5;
  border-radius: 3px;
  cursor: pointer;
  &.active {
    color: #ec345c;
    background-color: rgb(255, 230, 235);
    border-color: rgb(255, 215, 223);
  }
}
</style>